<template>
  <div class="section-white" >
    <div>
      <el-card class="box-card" style="width: 600px;margin: 30px ;">
        <div slot="header" class="clearfix">
          <span>预存款余额: <span style="color:firebrick">{{amount}}</span> 元</span>
        </div>
        <div  class="text item">
            <el-form ref="form" :model="form" label-width="120px">
              <el-form-item label="充值金额/元">
                <el-input v-model="form.amount" ></el-input>
                <span style="color: red;">正数充值,负数为扣款</span>
              </el-form-item>
              <el-form-item label="订单ID">
                <el-input type="text" v-model="form.order_id" placeholder="订单ID,无则为空" ></el-input>
              </el-form-item>
              <el-form-item label="交易ID">
                <el-input type="text" v-model="form.payment_id" placeholder="交易ID,无则为空" ></el-input>
              </el-form-item>
              <el-form-item label="充值说明">
                <el-input type="textarea" v-model="form.memo" placeholder="请输入充值说明" ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :disabled="isdisabled" @click="onSubmit">确认充值</el-button>
              </el-form-item>
            </el-form>
        </div>
      </el-card>
    </div>
    <div class="record-list">
      <el-table :data="recordList" @filter-change="filterTag" border v-loading="loading">
         <el-table-column prop="memo" label="摘要"></el-table-column>
         <el-table-column prop="message" label="备注"></el-table-column>
         <el-table-column prop="money" label="交易金额/元">
          <template slot-scope="scope">
             <span v-if="scope.row.explode_money ==0 " style="color:red">
              {{scope.row.import_money}}
             </span>
             <span  style="color:green"  v-else>
                 -{{scope.row.explode_money}}
             </span>
           </template>
         </el-table-column>
         <el-table-column prop="mtime" label="交易时间"></el-table-column>
         <el-table-column prop="order_id" label="订单ID"></el-table-column>
         <el-table-column prop="payment_id" label="交易ID"></el-table-column>
      </el-table>
    </div>
    <div v-if="total_count > params.pageSize"  class="content-padded tc">
<el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[20, 50,100,200]"
          :total="total_count" :page-size="params.pageSize">
        </el-pagination>
    </div>
  </div>
</template>

<script>

import { getUserDepositList,getUserDeposit,depositRecharge } from '../../../api/deposit'
export default {
  props: ['userId', 'isLoad'],
  data () {
    return {
      loading: false,
      trade_type: '',
      total_count: 0,
      pageSize:20,
      recordList: [],
      typeFilters: [
        { text: '充值记录', value: 'recharge' },
        { text: '赠送记录', value: 'recharge_gift' },
        { text: '消费记录', value: 'consume' },
        { text: '返佣记录', value: 'recharge_send' }
      ],
      params: {
        page: 1,
        pageSize: 20,
      },
      date_begin: '',
      date_end: '',
      amount:'',
      form:{
        amount:0,
        memo:'',
      },
      isdisabled:false,
    }
  },
  methods: {
    onSubmit(e){
      if(this.form.memo ==''){
           this.$message({
              type: 'warning',
              message: '请输入充值或者扣款说明!'
            });
            return false;
      }
       this.$confirm('你确认此次充值操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.form.member_id = this.userId;
          depositRecharge(this.form).then(res => {
              if(res.data.data.status){
                  this.$message({
                    type: 'success',
                    message: '操作成功!'
                  });
                  this.getList({pageSize: 20, page: 1, member_id: this.userId});
                  this.getRow();
                  this.isdisabled = true;
                  return true;
              }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消!'
          });
        });

    },
    filterTag (val) {
      if (val.type.length > 0 && val.type.length != this.typeFilters.length) {
        this.trade_type = val.type.join(',')
      } else {
        this.trade_type = ''
      }
      this.getParams()
      this.params.page = 1
      this.params.member_id = this.userId
      this.getList(this.params)
    },
    handleSizeChange(pageSize) {
      this.params.page = val;
      this.params.member_id = this.userId
      this.getList(this.params)
    },
    handleCurrentChange (val) {
      this.params.page = val;
      this.params.member_id = this.userId
      this.getList(this.params)
    },
    getList (query) {
      this.loading = true
      getUserDepositList(query).then(res => {
        this.recordList = res.data.data.list
        this.total_count = res.data.data.total_count
        this.loading = false
      })
    },
    getRow() {
      this.loading = true
      getUserDeposit({member_id:this.userId}).then(res => {
        console.log(res.data.data)
        this.amount = res.data.data.amount;
      })
    },
    getParams () {
      // this.params.date_begin = this.date_begin
      // this.params.date_end = this.date_end
      // this.params.mobile = this.mobile
      // this.params.shop_name = this.shop_name
      this.params.trade_type = this.trade_type
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    }
  },

  mounted () {
    // let query = {pageSize: this.pageSize, page: 1}
    // this.getList(query)
  },
  watch: {
    userId (newVal, oldVal) {
      if (this.isLoad) {
        let query = {pageSize: 20, page: 1, member_id: newVal}
        this.getList(query);

      }
    },
    isLoad (newVal, oldVal) {
      if (newVal) {
        let query = {pageSize: 20, page: 1, member_id: this.userId}
        this.getList(query);
         this.getRow();

      }
    }
  }
}
</script>
<style type="text/css">
  .record-list .el-table .cell, .record-list .el-table th > div {
    padding-left: 10px;
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// depositlist.vue?23c86048